export const DEFAULT_SEED = 1538;

export const WORLD = {
  groundY: 0,
  waterY: -0.8,
  quayBottomY: -1.1,
  farRingRadius: 45_000,
  cameraFar: 60_000,
  skyRadius: 50_000,
  skyDepthSentinel: 60_000,
} as const;

export const PLAYER = {
  eyeHeight: 1.7,
  radius: 0.3,
  walkSpeed: 1.4,
  runSpeed: 3.5,
  turnRadPerSecond: Math.PI,
  backwardSpeedFactor: 0.6,
  accelTime: 0.15,
  lookRadPerPx: 0.0022,
  pitchLimit: 1.48,
} as const;

export const FLY = {
  defaultSpeed: 25,
  minSpeed: 5,
  maxSpeed: 200,
  wheelFactor: 1.25,
  boostFactor: 3,
  responseTime: 0.35,
  minClearance: 2,
  maxAltitude: 3000,
} as const;

/* The rowing boat of the boat tour, under the visitor's own oars. The hull is the 5 x 1.6 m rowing
   boat of the harbour fleet. Speeds and turning are estimates for one rower at ease and pulling
   hard, not measured from a source. */
export const BOAT = {
  /** The seated eye above the water, and the room kept over it under a bridge. */
  eyeHeight: 1.45,
  headroom: 0.3,
  /** The bench the visitor sits on, aft of the middle of the hull. */
  benchAftM: 1,
  halfBeam: 0.8,
  /** The gunwale above the water: below it the boat is as wide as its hull. */
  freeboard: 0.5,
  /** Above the gunwale it is as wide as the people sitting along its middle. */
  crewHalfWidth: 0.3,
  /** Where along the hull each of the two widths is tested, in metres ahead of its middle. */
  hullStations: [-1.7, 0, 1.7],
  crewStations: [-1.8, -1.2, -0.6, 0, 0.6, 1.2, 1.8],
  rowSpeed: 1.6,
  pullSpeed: 3,
  backSpeed: 0.9,
  accelTime: 1.1,
  turnRate: 0.75,
  turnTime: 0.35,
  /** Beyond this the visitor is carried to or from the boat instead of stepping across. */
  stepM: 25,
  /** A boat left moored within this distance is boarded where it lies. */
  hailM: 30,
} as const;

export const WALK_DESCENT_ALTITUDE_M = 150;

export const FOV_RESTORE_TIME_S = 1.2;

export const CAMERA = {
  defaultFovYDeg: 60,
  nearMin: 0.1,
  nearMax: 20,
  nearPerMetreAltitude: 0.05,
} as const;

export const TRANSITION = {
  durationS: 4,
  arcLiftM: 200,
} as const;

/*
 * The glide that answers the first movement input at the painter view, 3 km out. The camera comes in
 * along the painter's own bearing to `altitudeM` over the ground the painter looked at: 300 m is far
 * enough for the widest view of the city and near enough that the houses read, and -45 degrees keeps
 * the frame's top edge below the horizon (controls/flyEntry.ts). 2.5 s is long enough to read as one
 * move, short enough that the input which asked for it is answered promptly.
 */
export const FLY_ENTRY = {
  durationS: 2.5,
  altitudeM: 300,
  pitchDeg: -45,
} as const;

export const CHUNK_SIZE = {
  fabric: 250,
  infrastructure: 2000,
} as const;

export const CLIPPER_SCALE = 1000;

export const BUDGET = {
  // User preference, 2026-10-08: a minute of startup is acceptable.
  buildMs: 60_000,
  /* Site stage budget: 500ms in Node. Rationale: total world build 857ms in headless Chromium
     Metal against binding 2000ms; output-preserving optimisation stalled at 366ms. */
  siteMs: 500,
  drawCalls: 300,
  /* Per view. PLAN amendment "Detail programme and triangle budget (2026-09-27)" raised it from
     1.5 M: the old cap stood in for the frame budget, which stays binding. */
  triangles: 3_000_000,
  geometryMB: 350,
  memoryMB: 500,
} as const;
